import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "../lib/utils";
import { ComponentProps } from "react";

export interface LabelProps extends ComponentProps<typeof LabelPrimitive.Root> {
  required?: boolean;
}

export const Label = ({ className, children, required, ...props }: LabelProps) => {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className
      )}
      {...props}
    >
      {required ? (
        <span className="min-w-0">
          {children}
          <span aria-hidden className="text-red-500">
            &#8202;*
          </span>
        </span>
      ) : (
        children
      )}
    </LabelPrimitive.Root>
  );
};
